<template>
  <div class="login-cont">
    <div class="session" v-loading="loading">
      <!-- <div class="left"></div> -->
      <form action="" class="log-in" autocomplete="off">
        <img
          v-if="$store.state.view == 'wap'"
          class="log-logo"
          src="@/assets/logo2.png"
          alt=""
        />
        <h4>和德数保 <span> 登录</span></h4>
        <p>和德数保管理系统</p>
        <div class="floating-label">
          <input
            placeholder="用户名"
            type="text"
            v-model="form.username"
            name="email"
            id="email"
            autocomplete="off"
          />
          <label for="email">用户名:</label>
          <div class="icon">
            <i class="el-icon-user"></i>
          </div>
        </div>
        <div class="floating-label">
          <input
            placeholder="密码"
            v-model="form.password"
            type="password"
            name="password"
            id="password"
            autocomplete="off"
          />
          <label for="password">密码:</label>
          <div class="icon">
            <i class="el-icon-lock"></i>
          </div>
        </div>
        <div class="floating-label verification-code">
          <input placeholder="验证码" v-model="form.code" type="text" name="code" id="code" autocomplete="off">
          <label for="code">验证码:</label>
          <div class="icon">
            <i class="el-icon-key"></i>
          </div>
          <button type="button" class="send-code-btn" @click="sendVerificationCode" :disabled="countdown > 0">
            {{ countdown > 0 ? `${countdown}秒后重试` : '发送验证码' }}
          </button>
        </div>
        <button type="button" @click="login">登录</button>
        <a class="discrete" target="_blank">© 2024 和德数保</a>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      loading: false,
      countdown: 0,
      form: {
        username: "",
        password: "",
        AppId: "busi-sys",
        code:""
      },
    };
  },
  created() {
    window.sessionStorage.clear();
    this.$utils.removeCache('token')
    this.$utils.removeCache('userRole')
    this.$utils.removeCache('btnIds')
    this.$utils.removeCache('menus')


    this.$init.token.accessToken = "";
    this.$init.user = {};

    // 菜单处理
    this.$init.btnIds = [];
    this.$init.menu = [];
    this.$init.userRole = [];

    this.$store.commit("clearTab");
  },
  methods: {
    sendVerificationCode () {
      const vm = this;

      if(this.form.username == ''){
        this.$message.error('请输入用户名');
        return
      }

      vm.loading = true;
      this.$http.post('/sendUserLoginCode', { userName: this.form.username }).then(function (response) {
        vm.loading = false;
        if (response.data.header.code == "A1000") {
          vm.$message.success('验证码已发送');
          vm.startCountdown();
        } else {
          vm.$message.error(response.data.header.msg);
        }
      })
          .catch(function (error) {
            vm.$message.error('服务异常');
            vm.loading = false;
          });
    },
    startCountdown () {
      this.countdown = 60;
      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
    login() {
      const vm = this;
      if (this.form.username == "") {
        this.$message.error("请输入用户名");
        return;
      } else if (this.form.password == "") {
        this.$message.error("请输入密码");
        return;
      }else if(this.form.code == ''){
        this.$message.error('请输入验证码');
        return;
      }
      vm.loading = true;
      let postData = this.form;
      this.$http
        .post("/login", postData)
        .then((res) => {
          vm.loading = false;
          if (res.data.header.code === "A1000") {
            vm.$init.token.accessToken = res.headers.token;
            vm.$utils.setCache("token", vm.$init.token.accessToken)

            vm.getRole()
            vm.getMenu()
          } else if (res.data.header.code === "B1000" || res.data.header.code === "E1000") {
            this.$message.error(res.data.header.msg);
          }
        })
        .catch(function (error) {
          vm.$message.error("服务异常");
          vm.loading = false;
        });
    },
    /**
     * 获取用户角色  -- 临时使用，之后被废弃
     */
    getRole() {
      this.$http
        .get(`/busiReimburesement/get/role`, { AppId: "busi-sys" })
        .then((res) => {
          if (res.data.header.code == "A1000") {
            this.$init.userRole = res.data.body.roleList;
            this.$utils.setCache("userRole", this.$init.userRole)
          }
        });
    },
    /**
     * 获取用户菜单
     */
    getMenu() {
      const vm = this;
      vm.loading = true;
      let postData = {};
      this.$http
        .get("/menuList", postData)
        .then(function (response) {
          vm.loading = false;
          if (response.data.header.code == "A1000") {
            const originList = response.data.body.list
            const mergeList = [
              {
                "id": "e337f753af42476783c7f7e826c07891",
                "parentId": "d906d3674d7c41ed92aa8524f11c5a0a",
                "name": "激励分佣",
                "sort": 1000,
                "href": "/overhaul/overhaulList",
                "icon": "",
                "isShow": "1"
              },
              {
                "id": "e337f753af42476783c7f7e826c07892",
                "parentId": "d906d3674d7c41ed92aa8524f11c5a0a",
                "name": "捷赔审核",
                "sort": 1000,
                "href": "/overhaul/overhaulList",
                "icon": "",
                "isShow": "1"
              },
              {
                "id": "e337f753af42476783c7f7e826c07893",
                "parentId": "d906d3674d7c41ed92aa8524f11c5a0a",
                "name": "理赔信息",
                "sort": 1000,
                "href": "/claimManagement/claimList",
                "icon": "",
                "isShow": "1"
              },
              {
                "id": "e337f753af42476783c7f7e826c07894",
                "parentId": "d906d3674d7c41ed92aa8524f11c5a0a",
                "name": "集运资料审核",
                "sort": 1000,
                "href": "/overhaul/overhaulList",
                "icon": "",
                "isShow": "1"
              },
              {
                "id": "e337f753af42476783c7f7e826c07896",
                "parentId": "d906d3674d7c41ed92aa8524f11c5a0a",
                "name": "人保投保",
                "sort": 1000,
                "href": "/overhaul/overhaulList",
                "icon": "",
                "isShow": "1"
              },
              {
                "id": "e337f753af42476783c7f7e826c07897",
                "parentId": "d906d3674d7c41ed92aa8524f11c5a0a",
                "name": "BI销量邮件配置",
                "sort": 1000,
                "href": "/overhaul/overhaulList",
                "icon": "",
                "isShow": "1"
              },
              {
                "id": "e337f753af42476783c7f7e826c07898",
                "parentId": "d906d3674d7c41ed92aa8524f11c5a0a",
                "name": "贵州移动IMEI导入",
                "sort": 1000,
                "href": "/overhaul/overhaulList",
                "icon": "",
                "isShow": "1"
              },
              {
                "id": "e337f753af42476783c7f7e826c07899",
                "parentId": "d906d3674d7c41ed92aa8524f11c5a0a",
                "name": "四川移动导入",
                "sort": 1000,
                "href": "/overhaul/overhaulList",
                "icon": "",
                "isShow": "1"
              },
              {
                "id": "e337f753af42476783c7f7e826c07100",
                "parentId": "d906d3674d7c41ed92aa8524f11c5a0a",
                "name": "机型库",
                "sort": 1000,
                "href": "/overhaul/overhaulList",
                "icon": "",
                "isShow": "1"
              },
              {
                "id": "e337f753af42476783c7f7e826c07101",
                "parentId": "d906d3674d7c41ed92aa8524f11c5a0a",
                "name": "BI可视化配置",
                "sort": 1000,
                "href": "/overhaul/overhaulList",
                "icon": "",
                "isShow": "1"
              },
              {
                "id": "e337f753af42476783c7f7e826c07102",
                "parentId": "d906d3674d7c41ed92aa8524f11c5a0a",
                "name": "BI可视化配置",
                "sort": 1000,
                "href": "/overhaul/overhaulList",
                "icon": "",
                "isShow": "1"
              },
              {
                "id": "e337f753af42476783c7f7e826c07103",
                "parentId": "d906d3674d7c41ed92aa8524f11c5a0a",
                "name": "保单导入",
                "sort": 1000,
                "href": "/overhaul/overhaulList",
                "icon": "",
                "isShow": "1"
              },
              {
                "id": "e337f753af42476783c7f7e826c07104",
                "parentId": "d906d3674d7c41ed92aa8524f11c5a0a",
                "name": "金科分销订单导入",
                "sort": 1000,
                "href": "/overhaul/overhaulList",
                "icon": "",
                "isShow": "1"
              },
              {
                "id": "e337f753af42476783c7f7e826c07105",
                "parentId": "d906d3674d7c41ed92aa8524f11c5a0a",
                "name": "资料审核",
                "sort": 1000,
                "href": "/overhaul/overhaulList",
                "icon": "",
                "isShow": "1"
              },
              {
                "id": "e337f753af42476783c7f7e826c07106",
                "parentId": "d906d3674d7c41ed92aa8524f11c5a0a",
                "name": "智能核保",
                "sort": 1000,
                "href": "/overhaul/overhaulList",
                "icon": "",
                "isShow": "1"
              },
              ...originList
            ]
            let resList = mergeList.map(e => {
              let obj = {
                url: e.href,
                parentId: e.parentId === response.data.body.rootMenuId ? "0": e.parentId,
                name: e.name,
                id: e.id,
              }
              if(e.href && e.href.indexOf('/') === 0){
                // 菜单
                obj.type = 1
              }else{
                // 按钮
                obj.type = 2
                let pUrl = ''
                for(let item of response.data.body.list){
                  if(item.id === obj.parentId){
                    pUrl = item.href
                    break
                  }
                }
                obj.id = pUrl + obj.url;
              }
              return obj
            })

            let menus = [];
            let btnIds = [];
            resList.forEach((e) => {
              if (e.type === 2) {
                btnIds.push(e.id);
              } else {
                menus.push(e);
              }
            });
            vm.$init.menu = menus;
            vm.$init.btnIds = btnIds;

            vm.$utils.setCache("menus", menus);
            vm.$utils.setCache("btnIds", btnIds);
            vm.$router.push("/");
            vm.$message.closeAll() // 清除所有消息
          } else {
            vm.$message.error(response.data.header.msg);
          }
        })
        .catch(function (error) {
          vm.$message.error("服务异常");
          vm.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.log-logo {
  display: block;
  width: 120px;
  margin: 0 auto;
  margin-bottom: 20px;
}
.login-cont {
  min-height: 100%;
  width: 100%;
  background-color: $color-theme1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(https://api.dujin.org/bing/1920.php);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
* {
  font-family: -apple-system, BlinkMacSystemFont, "San Francisco", Helvetica,
    Arial, sans-serif;
  font-weight: 300;
  margin: 0;
}
$primary: $color-theme1;
h4 {
  font-size: 24px;
  font-weight: 600;
  color: #000;
  opacity: 0.85;
}
label {
  font-size: 12.5px;
  color: #000;
  opacity: 0.8;
  font-weight: 400;
}
form {
  padding: 40px 30px;
  background: #fefefe;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 20px;
  width: 300px;
  margin: 0 auto;
  h4 {
    margin-bottom: 20px;
    color: rgba(#000, 0.5);
    span {
      color: rgba(#000, 1);
      font-weight: 700;
    }
  }
  p {
    line-height: 155%;
    margin-bottom: 5px;
    font-size: 14px;
    color: #000;
    opacity: 0.65;
    font-weight: 400;
    max-width: 200px;
    margin-bottom: 40px;
  }
}
a.discrete {
  color: rgba(#000, 0.4);
  font-size: 14px;
  border-bottom: solid 1px rgba(#000, 0);
  padding-bottom: 4px;
  margin-left: auto;
  font-weight: 300;
  transition: all 0.3s ease;
  margin-top: 40px;
  &:hover {
    border-bottom: solid 1px rgba(#000, 0.2);
  }
}
button {
  -webkit-appearance: none;
  width: auto;
  min-width: 100px;
  border-radius: 24px;
  text-align: center;
  padding: 15px 40px;
  margin-top: 5px;
  background-color: saturate($primary, 30%);
  color: #fff;
  font-size: 14px;
  margin-left: auto;
  font-weight: 500;
  box-shadow: 0px 2px 6px -1px rgba(0, 0, 0, 0.13);
  border: none;
  transition: all 0.3s ease;
  outline: 0;
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 2px 6px -1px rgba($primary, 0.65);
    &:active {
      transform: scale(0.99);
    }
  }
}
input {
  font-size: 16px;
  padding: 20px 0px;
  height: 56px;
  border: none;
  border-bottom: solid 1px rgba(0, 0, 0, 0.1);
  background: #fff;
  width: 280px;
  box-sizing: border-box;
  transition: all 0.3s linear;
  color: #000;
  font-weight: 400;
  -webkit-appearance: none;
  border-radius: 0;
  &:focus {
    border-bottom: solid 1px $primary;
    outline: 0;
    box-shadow: 0 2px 6px -8px rgba($primary, 0.45);
  }
}
.floating-label {
  position: relative;
  margin-bottom: 10px;
  width: 100%;
  label {
    position: absolute;
    top: calc(50% - 7px);
    left: 0;
    opacity: 0;
    transition: all 0.3s ease;
    padding-left: 44px;
  }
  input {
    width: calc(100% - 44px);
    margin-left: auto;
    display: flex;
  }
  .icon {
    position: absolute;
    top: 0;
    left: 0;
    height: 56px;
    width: 44px;
    display: flex;
    box-sizing: border-box;
    i {
      height: 30px;
      width: 30px;
      font-size: 24px;
      margin: auto;
      opacity: 0.15;
      transition: all 0.3s ease;
    }
  }
  input:not(:placeholder-shown) {
    padding: 28px 0px 12px 0px;
  }
  input:not(:placeholder-shown) + label {
    transform: translateY(-10px);
    opacity: 0.7;
  }
  input:valid:not(:placeholder-shown) + label + .icon {
    svg {
      opacity: 1;
      path {
        fill: $primary;
      }
    }
  }
  input:not(:valid):not(:focus) + label + .icon {
    animation-name: shake-shake;
    animation-duration: 0.3s;
  }
}
$displacement: 3px;
@keyframes shake-shake {
  0% {
    transform: translateX(-$displacement);
  }
  20% {
    transform: translateX($displacement);
  }
  40% {
    transform: translateX(-$displacement);
  }
  60% {
    transform: translateX($displacement);
  }
  80% {
    transform: translateX(-$displacement);
  }
  100% {
    transform: translateX(0px);
  }
}
.session {
  display: flex;
  flex-direction: row;
  height: auto;
  width: 360px;
  margin: auto auto;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 2px 6px -1px rgba(0, 0, 0, 0.12);
}
.left {
  width: 220px;
  height: auto;
  min-height: 100%;
  position: relative;
  background-image: url(../assets/img/Asaka.jpeg);
  background-size: cover;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  svg {
    height: 40px;
    width: auto;
    margin: 20px;
  }
}
@media screen and (max-width: 580px) {
  .left {
    display: none;
  }
}
.verification-code {
  input {
    width: calc(100% - 44px);
    padding-right: 100px;
  }
  .send-code-btn {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    min-width: 90px;
    padding: 8px 12px;
    font-size: 12px;
    background-color: $primary;
    color: #fff;
    border: none;
    border-radius: 20px;
    cursor: pointer;
    transition: all .3s ease;
    white-space: nowrap;
    &:hover:not(:disabled) {
      background-color: saturate($primary, 30%);
      transform: translateY(-50%) scale(1.05);
    }
    &:active:not(:disabled) {
      transform: translateY(-50%) scale(0.98);
    }
    &:disabled {
      background-color: #ccc;
      cursor: not-allowed;
      opacity: 0.6;
    }
  }
}
</style>